import React, { useState } from 'react';
import { Alert, Button } from '@cimpress/react-components';

const AlertDemo = () => {
  const [alertDismissed, setAlertDismissed] = useState(true);

  const toggleDismissed = () => setAlertDismissed(!alertDismissed);

  return (
    <div>
      <div className="row">
        <div className="col-md-6">
          <Alert
            title="Title: Dismissible alert"
            message="There is a button on the right to 'hide' this alert"
            dismissible={true}
          />
        </div>
        <div className="col-md-6">
          <Alert
            title="Title: Non-dismissible alert"
            message="The button on the right to 'hide' this alert is not shown"
            dismissible={false}
          />
        </div>
      </div>
      <div className="row">
        {['danger', 'info'].map(status => (
          <div key={status} className="col-md-6">
            <Alert status={status} message={`This is '${status}' alert`} dismissible={true} />
          </div>
        ))}
      </div>
      <div className="row">
        {['warning', 'success'].map(status => (
          <div key={status} className="col-md-6">
            <Alert status={status} message={`This is '${status}' alert`} dismissible={true} />
          </div>
        ))}
      </div>
      <div className="row">
        <div className="col-md-6">
          <Alert
            title="Title: Dismissible alert using an onDismiss callback"
            message="'Hiding' this alert will trigger a popup"
            dismissible={true}
            onDismiss={() => alert("The alert has been 'hidden'.")}
          />
        </div>
        <div className="col-md-6">
          <Alert
            title="Props control"
            message="you can control me with a button"
            dismissible={true}
            dismissed={alertDismissed}
            onDismiss={toggleDismissed}
          />
          <Button onClick={toggleDismissed}>Toggle me</Button>
        </div>
      </div>
    </div>
  );
};

export default AlertDemo;
